export default __webpack_public_path__ + "static/media/d40b588f39d72a979b245238afe7cb6a.svg";